import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, isAuthed } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (isAuthed) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, pw);
      toast.success("Welcome back, DaviDÉ.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center pt-24 pb-12 px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-white/10 bg-[#101010] p-10">
        <p className="overline mb-3">Studio Access</p>
        <h1 className="font-display text-4xl text-white tracking-tight mb-8">Admin Login</h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="overline block mb-2" style={{color:"var(--davide-muted)"}}>Email</label>
            <input data-testid="admin-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border border-white/20 px-4 py-3 text-white focus:border-[var(--davide-gold)] outline-none transition-colors" />
          </div>
          <div>
            <label className="overline block mb-2" style={{color:"var(--davide-muted)"}}>Password</label>
            <input data-testid="admin-password-input" type="password" required value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="w-full bg-transparent border border-white/20 px-4 py-3 text-white focus:border-[var(--davide-gold)] outline-none transition-colors" />
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-gold w-full justify-center mt-4">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
